<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import { useMessageContext } from '../provider.js';

import BaseBubble from './Base.vue';
import Icon from 'next/icon/Icon.vue';
import Button from 'next/button/Button.vue';

const { t } = useI18n();

const { content, createdAt, wgptAttributes } = useMessageContext();

const collapsed = ref(true);

const readableTime = computed(() =>
  messageTimestamp(createdAt.value, 'LLL d, h:mm a')
);

const operation = computed(() => {
  return wgptAttributes.value.operation;
});
</script>

<template>
  <div class="flex flex-col items-center gap-2" :class="{ 'mb-4': !collapsed }">
    <Button
      v-tooltip.top="readableTime"
      faded
      slate
      :icon="collapsed ? 'i-lucide-plus' : 'i-lucide-minus'"
      trailing-icon
      size="xs"
      class="!rounded-xl !py-1 !h-auto !bg-n-alpha-1 !text-n-slate-11 hover:!bg-n-alpha-2"
      @click="collapsed = !collapsed"
    >
      <template #default>
        <span class="text-sm">{{ content }}</span>
        <Icon icon="i-lucide-pickaxe" class="text-n-slate-10 size-3.5" />
      </template>
    </Button>

    <BaseBubble
      v-if="!collapsed"
      class="px-3 py-2 !rounded-xl flex flex-col items-stretch min-w-0 gap-3 w-full"
      data-bubble-name="activity"
    >
      <template
        v-for="(payload, index) of wgptAttributes.payload"
        :key="payload.id"
      >
        <div v-if="index" class="border-t border-n-weak" />

        <div>
          <p v-tooltip.top="payload.id" class="text-xs flex gap-1 m-0">
            <span class="text-n-slate-11">{{ payload.name }}</span>
            <span class="text-n-slate-9">·</span>
            <span class="text-n-slate-9">{{
              t(
                `WGPT_BOTS.MESSAGE_BUBBLES.TOOL_ACTIVITY.${operation.toUpperCase()}`
              )
            }}</span>
          </p>

          <p v-if="operation === 'tools_result'" class="text-xs">
            {{ payload.content }}
          </p>
          <p v-else-if="operation === 'tools_use'" class="text-xs">
            {{ payload.input }}
          </p>
        </div>
      </template>
    </BaseBubble>
  </div>
</template>
